import { IconImageM } from "@common/components/icons/IconsM"
import { IS_WEB } from "@common/utils/mobileUtils"
import { incrementTutorMessengerNotReadCount } from "@data/redux/actions/data"
import { isWebConfVisibleForStudent } from "@data/utility/dataUtils"
import * as Notifications from "expo-notifications"
import moment from "moment"
import React, { useEffect } from "react"
import { Platform, View } from "react-native"
import { useDispatch } from "react-redux"
import homeG from "../../assets/icons/menus-new/accueil-gris.png"
import home from "../../assets/icons/menus-new/accueil.png"
import tutorG from "../../assets/icons/menus-new/prof-gris.png"
import tutor from "../../assets/icons/menus-new/prof.png"
import { findClosestNextOccurrence } from "./account/onboarding/LiveRoomCard"
import TodoListScreen from "./activity/todo/TodoListScreen"
import MyCoachTabScreen from "./tutoring/MyCoachTabScreen"

export const studentTabScreens = (student) => {
    const iconSize = 56
    const dispatch = useDispatch()
    useEffect(() => {
        const subscription = Notifications.addNotificationReceivedListener(
            (notification) => {
                if (notification.request.content.data.path === "messages") {
                    dispatch(incrementTutorMessengerNotReadCount())
                }
            }
        )
        return () => subscription.remove()
    }, [])

    const countTutorsPrivateMessages = student?.live_sessions
        ?.filter(
            (ls, index, self) =>
                index === self.findIndex((t) => t.tutor?.id === ls.tutor?.id)
        )
        ?.map((ls) => ls?.unread_private_messages_count?.[ls?.tutor?.id])
        ?.reduce((acc, count) => acc + count, 0)

    const countMyTutorNotifications =
        (isWebConfVisibleForStudent(student) ? 1 : 0) +
        countTutorsPrivateMessages +
        student?.live_sessions?.filter((liveSession) => {
            const closestNextOccurrence = findClosestNextOccurrence([
                liveSession,
            ])

            const liveMoment = closestNextOccurrence?.date
                ? moment(closestNextOccurrence?.date)
                : null

            if (!liveMoment) return false

            return moment()?.isBetween(
                liveMoment?.clone()?.subtract(15, "minutes"),
                liveMoment?.clone()?.add(45, "minutes")
            )
        })?.length

    const mt = Platform.OS === "ios" || IS_WEB ? 0 : 40

    return [
        {
            name: "home",
            component: TodoListScreen,
            options: {
                headerTitle: "Activités",
                headerShown: false,
                tabBarItemStyle: {
                    width: iconSize + 100,
                },
                tabBarIcon: (status) => {
                    const renderMenuBtnContent = () =>
                        status?.focused ? (
                            <IconImageM
                                style={{ marginTop: -mt }}
                                width={iconSize}
                                source={home}
                            />
                        ) : (
                            <IconImageM
                                style={{ marginTop: -mt, opacity: 0.5 }}
                                width={iconSize}
                                source={homeG}
                            />
                        )
                    return IS_WEB ? (
                        renderMenuBtnContent()
                    ) : (
                        <View
                            style={{
                                marginTop: mt,
                            }}
                        >
                            {renderMenuBtnContent()}
                        </View>
                    )
                },
                tabBarBadge: null,
            },
        },
        {
            name: "tutor",
            component: MyCoachTabScreen,
            options: {
                headerTitle: "Mon masteur",
                headerShown: false,
                tabBarItemStyle: {
                    width: iconSize + 100,
                },
                tabBarIcon: (status) => {
                    const renderMenuBtnContent = () =>
                        status?.focused ? (
                            <IconImageM
                                style={{ marginTop: -mt }}
                                width={iconSize}
                                source={tutor}
                            />
                        ) : (
                            <IconImageM
                                style={{ marginTop: -mt, opacity: 0.5 }}
                                width={iconSize}
                                source={tutorG}
                            />
                        )
                    return IS_WEB ? (
                        renderMenuBtnContent()
                    ) : (
                        <View style={{ marginTop: mt }}>
                            {renderMenuBtnContent()}
                        </View>
                    )
                },
                tabBarBadge:
                    countMyTutorNotifications > 0
                        ? countMyTutorNotifications
                        : null,
            },
        },
    ]
}
